import VenderId from 'components/pages/Article/VenderId'
import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import NoindexRemoval from 'components/common/NoindexRemoval'
import { getArticles, getArticleCount } from 'utils/api'

const SearchByTagPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <VenderId {...props} />
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const venderUrlId = context.params?.venderUrlId
  const [articlesResult, articleCountResult] = await Promise.all([
    getArticles({ venderId: venderUrlId, limit: 20 }),
    getArticleCount({ venderId: venderUrlId }),
  ])
  const [articles, error] = articlesResult || []
  const [articleCount, countError] = articleCountResult || []

  if (error) {
    // API 失敗時 articles 為 undefined，原本會在 SSR render 時 crash（500）
    // 丟給 withSafeServerSideProps 分流
    throw error
  }

  return {
    props: {
      fallbackData: {
        articles: articles ?? [],
        articleCount: articleCount ?? 0,
      },
    },
  }
})

export default withLivingSinyi(SearchByTagPage)
